import { useCallback, useEffect, useState } from 'react';
import type { TripResponseArgs } from '@this/domain/trip/trip2';
import type { TripRealtimeInfo } from '../api';
import { fetchTripInfo } from '../api';

type PusherInfo = {
  key: string;
  channelPrefix: string;
};

export const useTrip = (tripId: string) => {
  const [trip, setTrip] = useState<TripResponseArgs | null>(null);
  const [pusherInfo, setPusherInfo] = useState<PusherInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const tripData: TripRealtimeInfo = await fetchTripInfo(tripId);
      setTrip(tripData.trip);
      setPusherInfo({
        key: tripData.pusherKey,
        channelPrefix: tripData.pusherChannelPrefix
      });
    } catch (e) {
      setError('旅程情報の取得に失敗しました。時間をおいて再度お試しください。');
    } finally {
      setLoading(false);
    }
  }, [tripId]);

  useEffect(() => {
    load();
  }, [load]);

  const refetch = useCallback(async () => {
    try {
      const tripData: TripRealtimeInfo = await fetchTripInfo(tripId);
      setTrip(tripData.trip);
    } catch (e) {
      // refetch時はエラーを出すだけにする（既存データを維持）
      console.error(e);
    }
  }, [tripId]);

  return { trip, pusherInfo, loading, error, refetch };
};
